module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-blocks-4ba723327e4810119f774f96fc56a6d8.svg";